import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@core/environments/environment';
import { Pagination } from '@core/models/pagination.model';
import { LoadingService } from './loading.service';
import { finalize, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  http = inject(HttpClient);
  BASE_URL = environment.ADMIN_BASE_URL + '/v1/account';
  loadingService = inject(LoadingService);

  getAccountAuditLogs(accountId: string) {
    return this.http.get(
      `${this.BASE_URL}/get-account-audit-log?account_id=${accountId}`
    );
  }
  getAllAuditLogs(
    data?: Pagination,
    search_text?: string
  ): Observable<AuditLogsListResponse> {
    const uniqueStateUrl = 'get-audit-logs';
    this.loadingService.setLoading(uniqueStateUrl, true);
    let url = `${this.BASE_URL}/get-all-audit-log`;
    let options: { params?: HttpParams } = {};

    if (search_text) {
      url = `${this.BASE_URL}/get-all-audit-log?${search_text}`;
    } else if (data?.size !== undefined && data?.skip !== undefined) {
      options.params = new HttpParams()
        .set('take', data.size)
        .set('skip', data.skip);
    }

    return this.http
      .get<AuditLogsListResponse>(url, options)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }
}

interface AuditLogsListResponse {
  status: string;
  message: string;
  data: {
    data: AuditLogData[];
    total_count: number;
  };
}

interface AuditLogData {
  id: string;
  action: string;
  entity: string;
  entity_id: string;
  user_id: string;
  timestamp: string;
  details: string;
}
